import React, { useState } from 'react';
import { useApp } from './provider';
import { Page, Column, Input, Button, Copy, Row } from './components';
export function AccountScreen() {
  const app = useApp();
  const [brief, setBrief] = useState('');
  const [signup, setSignup] = useState(false),
    [username, setUsername] = useState(''),
    [password, setPassword] = useState('');
  const submit = async () => {
    if (await app.authenticate(username, password, signup, brief)) setPassword('');
  };
  return (
    <Page title={signup ? 'Join VentureRoom' : 'Sign in'}>
      <Column gap={18}>
        <Input label="Username" value={username} onChange={setUsername} />
        {signup && (
          <Input
            label="What do you need help with? (optional)"
            value={brief}
            onChange={setBrief}
            multiline
          />
        )}
        <Input
          label="Password"
          secret
          value={password}
          onChange={setPassword}
          onSubmit={() => void submit()}
        />
        {signup && (
          <Copy muted>
            Use 3–40 letters or numbers for your username and at least 12 characters for your
            password.
          </Copy>
        )}
        {!!app.error && <Copy>{app.error}</Copy>}
        <Row>
          <Button disabled={app.busy} onPress={() => void submit()}>
            {app.busy ? 'Please wait…' : signup ? 'Create account' : 'Sign in'}
          </Button>
          <Button
            kind="quiet"
            onPress={() => {
              setSignup(!signup);
              setPassword('');
            }}
          >
            {signup ? 'Already have an account?' : 'Create an account'}
          </Button>
        </Row>
      </Column>
    </Page>
  );
}
